import { call, put, takeLatest } from 'redux-saga/effects';
import {
  PRODUCT_DATA_QUERY_START,
  ProductDataQueryStartAction,
  getProductDataQuerySuccessAction,
  getProductDataQueryFailedAction,
} from '../actions/ProductSearchAction';
import ApiUtil from 'src/utils/ApiUtil';
import { KeywordType, ProductMatchResult } from 'src/model/ProductMatch';
import {
  setSelectedProductQueryStart,
  setSwitchStoreNewStart,
  SWITCH_AMAZON_STORE_START,
  SwitchStoreStartAction,
} from 'src/actions/SelectedProductQueryAction';
import { isWidget } from 'src/config/Config';

export function* getProductData(
  action: ProductDataQueryStartAction | SwitchStoreStartAction,
) {
  try {
    // IRC pass MSKU as keywordType identifying searchKey type in productmatch method.
    const parameters: any = isWidget()
      ? {
          searchKey: action.searchKey,
          keywordType: KeywordType.MSKU,
          countryCode: action.countryCode,
        }
      : { searchKey: action.searchKey, countryCode: action.countryCode };
    // @ts-expect-error
    const response = yield call(
      ApiUtil.callApiWithTimeout,
      'productmatch',
      parameters,
    );
    yield put(getProductDataQuerySuccessAction(response));
    const productMatchResult: ProductMatchResult = response.data;
    // Auto-select the only product
    let product = null;
    if (
      productMatchResult?.myProducts != null &&
      productMatchResult.myProducts.totalProductCount === 1 &&
      productMatchResult.myProducts.products.length == 1
    ) {
      product = productMatchResult.myProducts.products[0];
      yield put(
        setSelectedProductQueryStart(
          productMatchResult.countryCode,
          product,
          action.itemPriceFromUrl,
          action.shippingCostFromUrl,
        ),
      );
    } else if (
      productMatchResult?.myProducts != null &&
      productMatchResult.myProducts.totalProductCount === 0 &&
      productMatchResult.otherProducts != null &&
      productMatchResult.otherProducts.totalProductCount === 1 &&
      productMatchResult.otherProducts.products.length == 1
    ) {
      product = productMatchResult.otherProducts.products[0];
      yield put(
        setSelectedProductQueryStart(
          productMatchResult.countryCode,
          product,
          action.itemPriceFromUrl,
          action.shippingCostFromUrl,
        ),
      );
    }
    // Auto-select for switch amazon store
    if ('SWITCH_AMAZON_STORE_START' == action.type) {
      if (
        productMatchResult?.myProducts != null &&
        productMatchResult.myProducts.totalProductCount > 1 &&
        productMatchResult.myProducts.products.length > 0
      ) {
        product = productMatchResult.myProducts.products[0];
        yield put(
          setSelectedProductQueryStart(
            productMatchResult.countryCode,
            product,
            action.itemPriceFromUrl,
            action.shippingCostFromUrl,
          ),
        );
      } else if (
        productMatchResult?.otherProducts != null &&
        productMatchResult.otherProducts.totalProductCount > 1 &&
        productMatchResult.otherProducts.products.length > 0
      ) {
        product = productMatchResult.otherProducts.products[0];
        yield put(
          setSelectedProductQueryStart(
            productMatchResult.countryCode,
            product,
            action.itemPriceFromUrl,
            action.shippingCostFromUrl,
          ),
        );
      } else if (product == null) {
        if ('product' in action) {
          yield put(setSwitchStoreNewStart(action.countryCode, action.product));
        }
      }
    }
  } catch (error) {
    console.error('Call API productmatch error' + error);
    yield put(getProductDataQueryFailedAction());
  }
}

export default function* productData() {
  yield takeLatest(
    [PRODUCT_DATA_QUERY_START, SWITCH_AMAZON_STORE_START],
    getProductData,
  );
}
